export const R2_PUBLIC_BASE_URL =
  process.env.REACT_APP_R2_PUBLIC_BASE_URL ||
  "https://docs.lefyr2.com";
